import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ImgFallbackModule } from 'ngx-img-fallback';

import { IbLayoutComponentsModule } from '@rs-bank/rs-layout';
import { RsUiKitModule } from '@rs-bank/rs-ui-kit';

import { OperationWizardModule } from '../../common/operation-wizard/operation-wizard.module';
import { AppealDocumentComponent } from '../../pages/profile/pages/appeals-2/appeal-detail.content-component-for-popup-component/components/appeal-document/appeal-document.component';
import { ProductSelectModule } from '../../shared/components/product-select/product-select.module';
import { SvgCommonModule } from '../../shared/svg/svg-common.module';
import { UiModule } from '../../ui/ui.module';

import { AppealBlockComponent } from './appeal-block/appeal-block.component';
import { AppealHidingTextComponent } from './appeal-hiding-text/appeal-hiding-text.component';
import { AppealItemComponent } from './appeal-item/appeal-item.component';
import { DocumentItemComponent } from './document-item/document-item.component';
import { DocumentOrderComponent } from './document-order/document-order.component';
import { DocumentSignWizardComponent } from './document-sign-wizard/document-sign-wizard.component';
import { DocumentsBlockComponent } from './documents-block/documents-block.component';
import { ReferenceOrderedComponent } from './references/reference-ordered/reference-ordered.component';
import { ReferencesBlockComponent } from './references/references-block/references-block.component';
import { ReferencesOrderProductSelectValueEmptyComponent } from './references/references-group-wizard/components/references-order-product-select-value-empty/references-order-product-select-value-empty.component';
import { ReferencesGroupWizardComponent } from './references/references-group-wizard/references-group-wizard.component';
import { ReferencesWithoutGroupWizardComponent } from './references/references-without-group-wizard/references-without-group-wizard.component';
import { SignAllStatementsWizardComponent } from './sign-all-statements-wizard/sign-all-statements-wizard.component';
import { SignedDocumentsComponent } from './signed-documents/signed-documents.component';
import { StatementATMWizardComponent } from './statement-ATM-wizard/statement-atm-wizard.component';
import { StatementBlockComponent } from './statement-block/statement-block.component';
import { StatementItemComponent } from './statement-item/statement-item.component';
import { StatementOrderComponent } from './statement-order/statement-order.component';
import { StatementsSectionComponent } from './statements-section.component';
import { StatementsService } from './statements.service';

@NgModule({
	imports: [
		CommonModule,
		ImgFallbackModule,
		OperationWizardModule,
		RouterModule,
		UiModule,
		SvgCommonModule,
		IbLayoutComponentsModule,
		ProductSelectModule,
		RsUiKitModule,
		ReferencesGroupWizardComponent,
		ReferencesGroupWizardComponent,
		ReferencesWithoutGroupWizardComponent,
		ReferenceOrderedComponent,
		AppealDocumentComponent,
	],
	declarations: [
		StatementsSectionComponent,
		ReferencesBlockComponent,

		ReferencesOrderProductSelectValueEmptyComponent,


		StatementATMWizardComponent,
		StatementBlockComponent,
		StatementOrderComponent,
		StatementItemComponent,
		AppealBlockComponent,
		AppealItemComponent,
		AppealHidingTextComponent,
		SignAllStatementsWizardComponent,
		DocumentsBlockComponent,
		DocumentItemComponent,
		DocumentOrderComponent,
		DocumentSignWizardComponent,
		SignedDocumentsComponent,
	],
	providers: [StatementsService],
	exports: [
		StatementATMWizardComponent,
		StatementsSectionComponent,
		SignAllStatementsWizardComponent,
		DocumentSignWizardComponent,
		DocumentsBlockComponent,
		ReferencesBlockComponent,
		AppealBlockComponent,
		StatementBlockComponent,
	],
})

export class StatementsSectionModule { }
